import PropTypes from 'prop-types';
import React from 'react';
import RecipientsList from '../../../../utils/recipients-list.js';
import StampDetailsTable from '../../../../utils/stamp-details-table.js';
import AttachedDocuments from '../../../../utils/attached-documents.js';
import StampDenominations from '../../../../utils/stamp-denominations.js';

const RenderDetails = ({
	displayedRecipients,
	file,
	downloadPDF,
	showAll,
	toggleShowAll,
	initialDisplayCount,
	totalRecipients = 0,
	showCompare = false,
	documentId = ''
}) => (
	<div>
		<div>
			<RecipientsList
				displayedRecipients={displayedRecipients}
				showAll={showAll}
				toggleShowAll={toggleShowAll}
				initialDisplayCount={initialDisplayCount}
				totalRecipients={totalRecipients}
				showCompare={showCompare}
				documentId={documentId}
				data={file}
			/>
		</div>
		<div>
			<StampDetailsTable
				stateName={file?.stateName ?? null}
				stampType={file?.stampType ?? null}
				stampAmount={file?.stampAmount ?? null}
			/>
		</div>
		{file?.stampDenominations && (
			<div>
				<StampDenominations stampDenominations={file?.stampDenominations} />
			</div>
		)}
		<AttachedDocuments
			documentAttachment={file?.documentAttachment}
			downloadPDF={downloadPDF}
		/>
	</div>
);

export default RenderDetails;

RenderDetails.propTypes = {
	displayedRecipients: PropTypes.any,
	file: PropTypes.any,
	downloadPDF: PropTypes.any,
	showAll: PropTypes.any,
	toggleShowAll: PropTypes.any,
	initialDisplayCount: PropTypes.any,
	totalRecipients: PropTypes.any,
	showCompare: PropTypes.bool,
	documentId: PropTypes.string
};
